module.exports = __webpack_public_path__ + "img/coming.soon.blue.33c05b82.png";